import styled from 'styled-components';
import { Link } from 'gatsby';
import { breakpoint } from '../../theme/breakpoint';

export const LogoWrapper = styled(Link)`
  display: flex;
  align-items: center;
  width: 80px;
  height: 40px;

  picture {
    margin: auto;
    width: 100%;

    ${breakpoint.desktop`
      height: 100%;
    `}
  }

  ${breakpoint.desktop`
    height: 120px;
    width: auto;

    img {
      height: 100%;
      width: auto;
    }
  `}
`;

export const LogoStyled = styled.picture`
  display: block;
  width: auto;
`;
